<!-- 会員情報確認画面コンポーネント -->
<template>
    <div v-show="!isApple">
        <slot name="note"></slot>
        <dl class="formContainer confirm">
            <template v-if="isEmailField">
                <dt>メールアドレス</dt>
                <dd>{{ userinfo.email }}</dd>
            </template>

            <dt>ＪリーグID</dt>
            <dd>{{ userinfo.jleague_id }}</dd>

            <template v-if="isSignup">
                <dt>パスワード</dt>
                <dd>**********</dd>
            </template>

            <dt>生年月日</dt>
            <dd>{{ userinfo.birthday_ymd | filterBirthday }}</dd>

            <template v-if="!isSignup || isSignupFull">
                <dt>氏名</dt>
                <dd>{{ '' | filterMemberName(userinfo.member_last_nm, userinfo.member_first_nm) }}</dd>
                <dt>氏名</dt>
                <dd>{{ '' | filterMemberName(userinfo.member_last_nm_kana, userinfo.member_first_nm_kana) }}</dd>
            </template>

            <dt>性別</dt>
            <dd>{{ userinfo.sex_kbn | filterSex }}</dd>

            <template v-if="!isSignup || isSignupFull">
                <dt>郵便番号</dt>
                <dd>{{ '' | filterPostCode(userinfo.post_cd1, userinfo.post_cd2) }}</dd>
            </template>

            <dt>都道府県</dt>
            <dd>{{ userinfo.address_state }}</dd>

            <template v-if="!isSignup || isSignupFull">
                <dt>市区町村</dt>
                <dd>{{ userinfo.address_city }}</dd>
                <dt>町域番地</dt>
                <dd>{{ userinfo.address_street }}</dd>
                <dt>建物号室</dt>
                <dd>{{ userinfo.address_building }}</dd>
                <dt>電話番号</dt>
                <dd>{{ userinfo.tel_no_fixed }}</dd>
            </template>

            <template v-if="isSignup">
                <dt>お気に入りクラブ</dt>
                <dd>{{ strFavoriteClubs }}</dd>
            </template>

            <template v-if="isSignup">
                <dt>お気に入り選手</dt>
                <dd v-html="formattedFavoritePlayers"></dd>
            </template>
        </dl>

        <template>
            <slot name="recaptchaUserInfo"></slot>
        </template>

        <div class="btnSpace duo">
            <button @click="back"
                    type="button"
                    class="return">戻る</button>
            <xhr-button v-if="isSignup"
                        :is-xhr="isXhr"
                        gtm-event-id="regist_confirm_tap2"
                        button-label="登録"
                        button-type="submit"></xhr-button>
            <xhr-button v-else
                        :is-xhr="isXhr"
                        button-label="登録"
                        button-type="submit"></xhr-button>
        </div>
        <div style="display: none">
            <button
                ref="siwa_signup_button"
                type="submit">
            </button>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import { mixinJleague, EnumClientDisplayPattern } from '../../mixin/utility'
import XhrButton from '../XhrButton'


export default {
    name: 'UserInfoConfirm',
    mixins: [mixinJleague],
    components: {
        'xhr-button': XhrButton
    },
    data: function(){
        return {}
    },
    props: {
        userinfo: {
            type: Object,
            required: true
        },
        formName: {
            type: String,
            default: ''
        },
        displayPattern: {
            type: String,
            default: EnumClientDisplayPattern.Full
        },
        isEmailField: {
            type: Boolean,
            default: false
        },
        isXhr: {
            type: Boolean,
            default: false
        },
        step: {
            type: String,
            default: ''
        },
        isApple: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isSignup: function(){
            return this.formName === 'signup';
        },
        isMinimum: function(){
            return this.displayPattern === EnumClientDisplayPattern.Minimum;
        },
        isNormal: function(){
            return this.displayPattern === EnumClientDisplayPattern.Normal;
        },
        isFull: function(){
            return this.displayPattern === EnumClientDisplayPattern.Full;
        },
        isSignupFull: function(){
            return this.isSignup && this.isFull;
        },
        strFavoriteClubs: function(){
            const self = this;
            let clubs = [];
            if (this.userinfo.club_cd){
                clubs = this.userinfo.club_cd.split(",");
            }
            return clubs.filter(function(code){
                return code !== 'JL';
            }).map(function(code){
                const club = self.getClubTeamByClubCode(code);
                return club.teamName;
            }).join('、');
        },
        formattedFavoritePlayers() {
            if (!this.userinfo || !this.userinfo.favorite_player_list || this.userinfo.favorite_player_list.length === 0) {
                return '';
            }

            return this.userinfo.favorite_player_list
                .filter(club => club.player_list && club.player_list.length > 0)
                .map(club => {
                    const clubInfo = this.getClubTeamByClubCode(club.club_cd);
                    const teamName = clubInfo.teamName;
                    const players = club.player_list.map((player, index) => 
                        `・${player.position} ${player.uniform_number} ${player.player_name}`
                    ).join('<br>');
                    return `${teamName}<br>${players}`;
                })
                .join('<br><br>');
        }
    },
    filters: {
        filterBirthday: function(value){
            return (value !== '')? dayjs(value).format('YYYY年MM月DD日'): '';
        },
        filterMemberName: function(value, last, first){
            return [last, first].join("　");
        },
        filterSex: function(value){
            // String型とNumber型が混在しているときがあるので文字列にして評価する
            const sex = value.toString();
            switch (sex) {
                case '0':
                    return '無回答';
                case '1':
                    return '男性';
                case '2':
                    return '女性';
                default:
                    return '無回答'
            }
        },
        filterPostCode: function(value, a, b){
            // e.g. 100-0001
            return (a !== '' && b !== '')?  [a, b].join('-'): value;
        }
    },
    methods: {
        back: function(){
            this.$emit('back', this.step);
        },
        autoSignup: function () {
            this.$refs.siwa_signup_button.click();
        }
    }
}
</script>